import { render } from "./BaseBackground.vue?vue&type=template&id=23acc271&scoped=true"
import script from "./BaseBackground.vue?vue&type=script&lang=js"
export * from "./BaseBackground.vue?vue&type=script&lang=js"

import "./BaseBackground.vue?vue&type=style&index=0&id=23acc271&scoped=true&lang=css"

import exportComponent from "/Users/andrewrexroth/SourceCode/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.39_vue@3.5.39_typescript@5.9.3__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23acc271"]])

export default __exports__